import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";
import {DeleteModal, SelectMain} from "components";
import {allStatusesList, MainDetails, ResetPassword} from "fragments";
import {userDetails} from "./constants";
import {useModal, usePrimaryModal} from "utils";
import {usersActions} from "store";
import {Svg} from "assets";

const ACTION_DELETE = "DELETE_USER";

export const UserSingle = ({item, afterSuccess}) => {
    const {control, setValue} = useForm();
    const dispatch = useDispatch();
    const {close} = useModal();
    const {openPrimary, closePrimary} = usePrimaryModal();


    useEffect(() => {
        if (item?.status) {
            setValue('status', item?.status)
        }
    }, [item?.status]);


    const changeStatus = (status) => {
        dispatch(usersActions.changeStatus(item?.id, {status}))
    }

    const handleDelete = () => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(usersActions.deleteUser(item?.id));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    close();
                    closePrimary();
                    afterSuccess()
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };


    const handleResetPassword = () => {
        openPrimary(
            <ResetPassword id={item?.id}/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 508
            },
        );
    }

    return (
        <div className="users-single-wrapper">
            <div className="modal-header-main">
                <h2 className="modal-header-title">{item?.firstName}</h2>

                <div className="align-center" style={{gap: 8}}>
                    <div style={{minWidth: 145}}>
                        <SelectMain
                            list={allStatusesList}
                            renderLabel={(option) => option.name}
                            name='status'
                            control={control}
                            placeholder="Status"
                            selectedValue={'id'}
                            allowError={false}
                            disableClearable
                            handleChange={changeStatus}
                        />
                    </div>

                    {/*<button className="reset-btn" onClick={handleDelete}>*/}
                    {/*    <Svg.TrashSvg/>*/}
                    {/*</button>*/}

                    <button
                        className="modal-close-btn-main"
                        type="button"
                        onClick={close}
                    >
                        <Svg.CloseSvg/>
                    </button>
                </div>
            </div>

            <div className="modal-body-main">
                <MainDetails
                    info={userDetails(item)}
                    AnotherBlock={
                        <div className='details-reset-password-wrapper'>
                            <button
                                type='button'
                                className='details-reset-password-btn'
                                onClick={handleResetPassword}
                            >
                                <Svg.LockPassSvg/>
                                Reset Password
                            </button>
                        </div>
                    }
                />
            </div>
        </div>
    );
};
